export default class RegexHandler{

	static escapeRegex(string: string) {
		return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	} 
}
